import React, { useState } from 'react';
import { Pizza, Beef, Sandwich, Drumstick, UtensilsCrossed, Wheat, Salad } from 'lucide-react';
import { MenuCategoryCard } from './MenuCategoryCard';
import { MenuModal } from './MenuModal';
import { menuCategoryImages } from '../data/menuImages';

export const MenuSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('burgers');

  const categories = [
    { id: 'burgers', title: 'Burgers', icon: Beef, image: menuCategoryImages.burgers },
    { id: 'pizzas', title: 'Pizzas', icon: Pizza, image: menuCategoryImages.pizzas },
    { id: 'sandwiches', title: 'Sandwichs', icon: Sandwich, image: menuCategoryImages.sandwiches },
    { id: 'panuozzo', title: 'Panuozzo', icon: Wheat, image: menuCategoryImages.panuozzo },
    { id: 'salades', title: 'Nos Salades', icon: Salad, image: menuCategoryImages.salades },
    { id: 'texmex', title: 'Tex-Mex', icon: Drumstick, image: menuCategoryImages.texmex },
    { id: 'autres', title: 'Autres', icon: UtensilsCrossed, image: menuCategoryImages.autres }
  ];

  const handleCategoryClick = (categoryId) => {
    setSelectedCategory(categoryId);
    setIsModalOpen(true);
  };

  return (
    <section id="menu" className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#D4A85F] mb-4"
            style={{ fontFamily: "'Crimson Text', 'Times New Roman', serif" }}
          >
            Notre Menu
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Cliquez sur une catégorie pour découvrir nos spécialités
          </p>
        </div>

        {/* Menu Category Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories.map((category) => (
            <MenuCategoryCard
              key={category.id}
              title={category.title}
              image={category.image}
              icon={category.icon}
              onClick={() => handleCategoryClick(category.id)}
            />
          ))}
        </div>

        {/* Menu Modal */}
        <MenuModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          initialCategory={selectedCategory}
        />
      </div>
    </section>
  );
};
